var _style, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlateIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.5 21.8",
    style: {
      enableBackground: "new 0 0 26.5 21.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n#plate-icon .st0 {\n  fill: none;\n  stroke: #7c7c7c;\n  stroke-linejoin: round;\n}\n#plate-icon .st1 {\n  fill: none;\n  stroke: #7c7c7c;\n}\n#plate-icon .st2 {\n  fill: #7c7c7c;\n}\n#plate-icon .st3 {\n  fill: #ffffff;\n}\n#plate-icon .st4 {\n  fill: none;\n  stroke: #7e7e7e;\n}\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plate-icon"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.3,
    y: 4.2,
    className: "st0",
    width: 18,
    height: 14
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_411",
    transform: "translate(600 335)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_416",
    transform: "translate(600 339)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -592.7,
    cy: -327.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -588.7,
    cy: -331.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_422",
    transform: "translate(600 343)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: -592.7,
    cy: -327.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_412",
    transform: "translate(604 335)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_415",
    transform: "translate(604 339)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_421",
    transform: "translate(604 343)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -592.7,
    cy: -327.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -592.7,
    cy: -331.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_413",
    transform: "translate(608 335)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: -592.7,
    cy: -327.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_417",
    transform: "translate(612 335)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: -592.7,
    cy: -327.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_418",
    transform: "translate(612 339)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: -592.7,
    cy: -327.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_419",
    transform: "translate(612 343)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_414",
    transform: "translate(608 339)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_420",
    transform: "translate(608 343)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -592.7,
    cy: -327.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: -592.7,
    cy: -331.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: -592.7,
    cy: -327.8,
    r: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlateIcon);
export default __webpack_public_path__ + "static/media/plate-icon.9c43fe17.svg";
export { ForwardRef as ReactComponent };